import * as React from "react";

export function About() {
  return (
    <>
      <h1>About</h1>
      <p>This is the about page, nothing to see here yet...</p>
    </>
  );
}
